import Image from "next/image";
import React, { useEffect, useState } from 'react'
import styles from './ChooseCityCard.module.scss'
import CitySelector from '../CitySelector/CitySelector'
import { inject, observer, useObserver } from 'mobx-react'
import { get_city_label, sendMetrics } from '../../../../utils/misc'
import successImg from '../../../../new-images/profile/success.svg';

const ChooseCityCard: React.FC<{
  authStore: any,
  selectedCityStore: any,
  citiesStore: any,
  successCallback: any
}> = ({
  authStore,
  selectedCityStore,
  citiesStore,
  successCallback
}) => {

  const [userState, setUserState] = useState({
    user: authStore.user,
    cityOptions: [],
    selectedCity: null,
    updateUser: null,
  })
  const [submitState, setSubmitState] = useState(false)
  const [value, setValue] = useState("")

  useEffect(() => {
    citiesStore.filter({ s: value || "" })
      .then((items) => {
        const opt = items.map((item) => {
          const label = get_city_label(item.data);
          return { value: item.data.id, label: label };
        });

        setUserState({
          ...userState,
          cityOptions: opt
        })
      })
  }, [value])

  const handleCitySelect = (e) => {
    const { value } = e;
    setUserState({
      ...userState,
      selectedCity: e,

      updateUser: {
        ...userState.updateUser,
        city_id: value
      },

      user: {
        ...userState.user,
        city_id: value
      }
    })
  }
  
  const handleSearch = (e) => {
    setValue(e)
  }
  
  const setUserCookieCityId = (user) => {
    selectedCityStore.setCityId(user.city_id);
    if (user.city_id === 1) {
      selectedCityStore.setCity("Moscow");
    } else {
      selectedCityStore.setCity("Other");
    }
  };

  const handleSubmit = (e) => {
    sendMetrics("save_personal_settings");
    e.preventDefault()
    e.target.disabled = true

    authStore
      .update(userState.updateUser)
      .then((user) => {
        setUserCookieCityId(user)
        setUserState({
          ...userState,
          updateUser: {},
          user: user,
        })
      })
      .then(() => {
        setSubmitState(true)
        setTimeout(() => {
          successCallback()
        }, 3000);
      })
  }

  return (
    <>
      <div className={styles.header}>
        <h5 className={styles.title}>
          Мероприятия
        </h5>
      </div>

      <div className={styles.body}>
        <p className={styles.description}>
          Пожалуйста, укажите город, чтобы получать актуальную информацию о потребностях центров крови и мероприятиях.
        </p>

        <div className={styles.citySelector}>
          <span>Город</span>

          <CitySelector
            placeholder={"Выберите город"}
            selectorStyle={123}
            id={"city_id_test"}
            options={userState.cityOptions}
            onInputChange={handleSearch}
            onChange={handleCitySelect}
            value={userState.selectedCity}
            notFounded={false}
            disabled={false}
          />
        </div>

        <p className={styles.helpMsg}>
          Если не нашли свой город, напишите нам на <a href='mailto:support@donorsearch.org'>support@donorsearch.org</a>
        </p>
      </div>

      <div className={styles.footer}>
        { !submitState
          ? (
            <button
              className={`${styles.cardBtn} ${styles.cardBtn_Green}`}
              onClick={handleSubmit}
            >
              Сохранить изменения
            </button>
          ) : (
            <div className={styles.successLabel}>
              <Image
                src={successImg}
                alt="succes"
                width={20}
                height={20}
              />
              <span>Сохранено</span>
            </div>
          )
        }
      </div>
    </>
  )
}

export default inject(
  'authStore',
  'selectedCityStore',
  'citiesStore',
  'randomActivitiesStore',
)(observer(ChooseCityCard));